<div class="w-full mx-auto p-6 rounded-lg">
    <div class="flex items-center mb-4">
        <div class="titre3 dark:text-white">{{ 'DIFFUSION.CONFIRMATION_TITLE_SUCCESS' | translate }}</div>
    </div>

    <p class="mb-4 text-gray-700 dark:text-gray-300">
        {{ 'DIFFUSION.DIFFUSION_CREATED_SUCCESS' | translate }}
    </p>
    <div class="flex justify-end mt-4">
        <button (click)="onClose()" type="button" class="btn-primary-novo">
            {{ 'COMMUN.CLOSE' | translate }}
        </button>
    </div>
</div>